import { render, staticRenderFns } from "./CandidateCustomEvaluation.vue?vue&type=template&id=052d2789&scoped=true"
import script from "./CandidateCustomEvaluation.vue?vue&type=script&lang=js"
export * from "./CandidateCustomEvaluation.vue?vue&type=script&lang=js"
import style0 from "./CandidateCustomEvaluation.vue?vue&type=style&index=0&id=052d2789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d2789",
  null
  
)

export default component.exports